// host.ts — is this page served from a recognized backlit host?
// Ported from the old mode.ts suffix list. Off-host the SDK has no data-API
// to talk to, so every data op throws unsupported_host.
import { BacklitError } from "./errors.js";

export function isBacklitHost(): boolean {
  if (typeof globalThis === "undefined") return true; // fail open (non-browser harness)
  const g = globalThis as { location?: Location };
  const loc = g.location;
  if (!loc) return true;                  // fail open: no origin to mis-target
  if (loc.protocol === "file:") return false;
  const host = (loc.hostname ?? "").toLowerCase();
  if (host === "") return false;
  return (
    host.endsWith(".backlit.run") ||
    host.endsWith(".backlitdev.run") ||
    host.endsWith(".localtest.me") ||
    host === "localhost" || host.endsWith(".localhost")
  );
}

// apexHost is the platform apex this glow host sits under (the offline
// reachability probe's first layer): *.backlit.run → "backlit.run",
// *.backlitdev.run → "backlitdev.run"; null for every other host (localtest.me,
// localhost, *.localhost), which have no apex to probe.
export function apexHost(): string | null {
  const host = ((globalThis as { location?: Location }).location?.hostname ?? "").toLowerCase();
  if (host.endsWith(".backlit.run")) return "backlit.run";
  if (host.endsWith(".backlitdev.run")) return "backlitdev.run";
  return null;
}

export function assertOnBacklitHost(): void {
  if (isBacklitHost()) return;
  const h = (globalThis as { location?: Location }).location?.hostname ?? "this page";
  throw new BacklitError(
    "unsupported_host",
    `the Backlit SDK only works on a deployed glow (*.backlit.run); served from ${h}`,
  );
}
